import FormGroup from "@mui/material/FormGroup";
import FormHelperText from "@mui/material/FormHelperText";
import TextField from "@mui/material/TextField";
import Five9Connector, { Five9FormValues } from "../models/Five9Connector";
import { Controller, FieldErrors, UseFormRegister } from "react-hook-form";
import { ConnectorWizardFormValues } from "./ConnectorWizard";
import { useTranslation } from "react-i18next";
import { ConnectorSecretField } from "../input/ConnectorSecretField";

export interface Five9ConfigFormProps {
  register: UseFormRegister<ConnectorWizardFormValues>;
  defaultValues: Five9FormValues;
  errors?: FieldErrors<
    ConnectorWizardFormValues & Record<"Five9", Five9FormValues>
  >;
}

const Five9ConfigForm = ({
  register,
  defaultValues,
  errors,
}: Five9ConfigFormProps) => {
  const { t } = useTranslation(["auth", "five9Connector"]);
  const registerPrefix = Five9Connector.Type;

  return (
    <>
      <FormGroup>
        <Controller
          name={`${registerPrefix}.username`}
          render={({ field }) => (
            <ConnectorSecretField
              {...field}
              label={t("five9Connector:username")}
              defaultValue={defaultValues.username?.value}
              error={!!errors?.Five9?.username}
              required
            />
          )}
        />
        {errors?.Five9?.username?.message && (
          <FormHelperText error>
            <>{t(errors.Five9.username.message)}</>
          </FormHelperText>
        )}
      </FormGroup>
      <FormGroup>
        <Controller
          name={`${registerPrefix}.password`}
          render={({ field }) => (
            <ConnectorSecretField
              {...field}
              label={t("auth:password")}
              defaultValue={defaultValues.password?.value}
              error={!!errors?.Five9?.password}
              required
            />
          )}
        />
        {errors?.Five9?.password?.message && (
          <FormHelperText error>
            <>{t(errors.Five9.password.message)}</>
          </FormHelperText>
        )}
      </FormGroup>
      <FormGroup>
        <TextField
          {...register(`${registerPrefix}.reportName`)}
          label={t("five9Connector:reportName")}
          defaultValue={defaultValues.reportName}
          error={!!errors?.Five9?.reportName}
          autoComplete="off"
          required
        />
        {errors?.Five9?.reportName?.message && (
          <FormHelperText error>
            <>{t(errors.Five9.reportName.message)}</>
          </FormHelperText>
        )}
      </FormGroup>
      <FormGroup>
        <TextField
          {...register(`${registerPrefix}.folderName`)}
          label={t("five9Connector:folderName")}
          defaultValue={defaultValues.folderName}
          error={!!errors?.Five9?.folderName}
          autoComplete="off"
          required
        />
        {errors?.Five9?.folderName?.message && (
          <FormHelperText error>
            <>{t(errors.Five9.folderName.message)}</>
          </FormHelperText>
        )}
      </FormGroup>
    </>
  );
};

export default Five9ConfigForm;
